import styled from 'styled-components';

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    color: #fff;
    font-weight: bold;
  }
`;